export default "__VITE_ASSET__Dj1tmiNs__"